




























import { Component, Prop, Emit, Vue } from 'vue-property-decorator';

@Component
export default class Popup extends Vue {
	@Prop()
	title!: string;

	@Prop()
	content!: [];

	@Emit()
	onCloseClick(): void {}

	public marginTop = -5;
	public marginLeft = 11;
	public height: string = 'auto';
	private clientRect!: any;

	private checkYPositionOk(): boolean {
		return !(
			this.clientRect.bottom >
			(window.innerHeight || document.documentElement.clientHeight) - 114
		);
	}

	private checkXPositionOk(): boolean {
		return !(
			this.clientRect.right >
			(window.innerWidth || document.documentElement.clientWidth)
		);
	}

	protected mounted(): void {
		if (!this.$store.getters.getIsMobile) {
			this.clientRect = this.$el.getBoundingClientRect();
			if (!this.checkYPositionOk()) {
				if (this.clientRect.top - this.clientRect.height < 0) {
					this.marginTop = -this.clientRect.height / 2 - 2;

					if (
						this.clientRect.top < 0 ||
						this.clientRect.bottom >
							(window.innerHeight ||
								document.documentElement.clientHeight)
					) {
						this.height = '500px';
					}
				} else {
					this.marginTop = -this.clientRect.height - 5;
				}
			}

			if (!this.checkXPositionOk()) {
				this.marginLeft = -this.clientRect.width + 11;
			}
		} else {
			this.marginTop = 0;
			this.marginLeft = 0;
		}
	}
}
